/**
 * @file Shared detail-view shell composition helpers.
 */

/**
 * Renders the common detail-view form shell and bottom action row.
 * @param {object} params Shell render parameters.
 * @param {string} params.itemType Current item type.
 * @param {string} params.fieldsHtml Detail form fields HTML.
 * @param {string} params.sectionsHtml Detail section HTML after the form.
 * @returns {string} Detail shell HTML.
 */
export function renderDetailShell({
    itemType,
    fieldsHtml,
    sectionsHtml,
}) {
    const deleteLabel = itemType.charAt(0).toUpperCase() + itemType.slice(1);
    const secondaryButtonClasses = [
        'inline-flex',
        'h-9',
        'items-center',
        'justify-center',
        'rounded-md',
        'bg-gray-200',
        'px-4',
        'text-sm',
        'font-semibold',
        'text-gray-800',
        'transition-colors',
        'hover:bg-gray-300',
        'focus:outline-none',
        'disabled:cursor-not-allowed',
        'disabled:opacity-70',
    ].join(' ');
    const dangerButtonClasses = [
        'inline-flex',
        'h-9',
        'items-center',
        'justify-center',
        'rounded-md',
        'bg-red-600',
        'px-4',
        'text-sm',
        'font-semibold',
        'text-white',
        'transition-colors',
        'hover:bg-red-700',
        'focus:outline-none',
    ].join(' ');
    const mobileBarButtonClasses = [
        'inline-flex',
        'h-11',
        'min-w-0',
        'items-center',
        'justify-center',
        'rounded-md',
        'px-4',
        'text-sm',
        'font-semibold',
        'transition-colors',
        'focus:outline-none',
    ].join(' ');
    const mobileSecondaryButtonClasses = [
        mobileBarButtonClasses,
        'bg-gray-200',
        'text-gray-800',
        'hover:bg-gray-300',
    ].join(' ');
    const mobileSaveButtonClasses = [
        mobileBarButtonClasses,
        'bg-gray-200',
        'text-gray-800',
        'hover:bg-gray-300',
        'disabled:cursor-not-allowed',
        'disabled:opacity-70',
    ].join(' ');
    const mobileMoreButtonClasses = [
        'inline-flex',
        'h-11',
        'w-11',
        'items-center',
        'justify-center',
        'rounded-md',
        'bg-gray-200',
        'text-gray-800',
        'transition-colors',
        'hover:bg-gray-300',
        'focus:outline-none',
    ].join(' ');

    return `
        <div class="hidden justify-between items-center mb-6 md:flex">
            <button type="button" id="details-back-btn" class="${secondaryButtonClasses}">Back</button>
            <button type="button" id="details-save-btn" class="details-save-btn ${secondaryButtonClasses}" disabled>Save</button>
        </div>
        <form id="details-form">
            ${fieldsHtml}
            </form>

        ${sectionsHtml}

        <div class="hidden justify-between items-center mt-8 pt-4 border-t border-gray-200 md:flex">
            <button type="button" id="delete-item-btn-bottom" class="${dangerButtonClasses}">Delete ${deleteLabel}</button>
            <button type="button" id="details-save-btn-bottom" class="details-save-btn ${secondaryButtonClasses}" disabled>Save</button>
        </div>

        <div class="detail-mobile-action-spacer md:hidden" aria-hidden="true"></div>
        <div class="detail-mobile-action-bar md:hidden">
            <button type="button" id="details-back-btn-mobile" class="${mobileSecondaryButtonClasses}">Back</button>
            <details class="detail-mobile-more-menu">
                <summary class="${mobileMoreButtonClasses}" aria-label="More detail actions" title="More">
                    <span class="material-symbols-outlined text-[22px] leading-none">more_vert</span>
                </summary>
                <div class="detail-mobile-more-menu__panel">
                    <button type="button" id="delete-item-btn-mobile" class="detail-mobile-delete-action">
                        Delete ${deleteLabel}
                    </button>
                </div>
            </details>
            <button type="button" id="details-save-btn-mobile" class="details-save-btn ${mobileSaveButtonClasses}" disabled>Save</button>
        </div>
    `;
}
